var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade quick-ehr",
      attrs: {
        id: "healtgdocumentmodal",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "exampleModalCenterTitle",
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog wider-1", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "h5",
                {
                  staticClass: "modal-title",
                  staticStyle: { margin: "0 auto" },
                },
                [_vm._v("Health Documents")]
              ),
              _c(
                "button",
                {
                  staticClass: "close",
                  staticStyle: { top: "-17px" },
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    "aria-label": "Close",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.closeHealthDocument()
                    },
                  },
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×"),
                  ]),
                ]
              ),
            ]),
            _c("div", { staticClass: "modal-body p-3" }, [
              _vm.showspinner ? _c("div", [_vm._m(0)]) : _vm._e(),
              _c("div", { staticClass: "row no-gutter-mr" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "health-documents" }, [
                    _c("div", { staticClass: "file-upload" }, [
                      _c("input", {
                        ref: "fileInput",
                        staticClass: "input-padding",
                        attrs: {
                          type: "file",
                          accept: ".png, .jpg, .jpeg, .pdf",
                        },
                        on: { change: _vm.handleFiles },
                      }),
                      _c(
                        "button",
                        {
                          staticClass: "primary-btn pull-right ripple",
                          class: {
                            "global-disabled": !_vm.selectedFiles.length,
                          },
                          attrs: { disabled: !_vm.selectedFiles.length },
                          on: { click: _vm.uploadFilesBase64 },
                        },
                        [_vm._v("Upload")]
                      ),
                      _c(
                        "a",
                        {
                          staticStyle: {
                            background: "#0056e0",
                            border: "0",
                            color: "#fff",
                            "font-size": "16px",
                            padding: "9px 20px 8px",
                            "margin-left": "10px",
                          },
                          attrs: { href: "javascript:void(0);" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchDocuments()
                            },
                          },
                        },
                        [_c("i", { staticClass: "fa fa-refresh" })]
                      ),
                    ]),
                    _vm._m(1),
                    _vm.fileWarning
                      ? _c(
                          "p",
                          {
                            staticStyle: { color: "red", "margin-top": "5px" },
                          },
                          [_vm._v(_vm._s(_vm.fileWarning))]
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "upload-document" }, [
                      _c("h3", [_vm._v("Uploaded Documents")]),
                      _c(
                        "table",
                        {
                          staticClass:
                            "table responsive mt-3 dashboard- staff-table",
                        },
                        [
                          _vm._m(2),
                          _c(
                            "tbody",
                            [
                              !_vm.documents || _vm.documents.length === 0
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "text-center",
                                        attrs: { colspan: "3" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                        No documents available\n                      "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._l(
                                    _vm.paginatedDocuments,
                                    function (doc, index) {
                                      return _c("tr", { key: doc.s3Key }, [
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              (_vm.currentPage - 1) *
                                                _vm.documentsPerPage +
                                                index +
                                                1
                                            )
                                          ),
                                        ]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              doc.fileName.substring(
                                                doc.fileName.indexOf("_") + 1
                                              )
                                            )
                                          ),
                                        ]),
                                        _c("td", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: "javascript:void(0);",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openFile(doc.s3Key)
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-eye",
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: "javascript:void(0);",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteFile(
                                                    doc.unique_id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-trash",
                                              }),
                                            ]
                                          ),
                                        ]),
                                      ])
                                    }
                                  ),
                            ],
                            2
                          ),
                        ]
                      ),
                      _vm.paginatedDocuments &&
                      _vm.paginatedDocuments.length > 0
                        ? _c(
                            "div",
                            { staticClass: "col-md-12 pull-left text-center" },
                            [
                              _c(
                                "ul",
                                { staticClass: "main-pagination mt-3 mb-3" },
                                [
                                  _vm.currentPage > 1
                                    ? _c("li", [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "pagination-previous",
                                            attrs: { href: "" },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.showPage(
                                                  _vm.currentPage - 2
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "i",
                                              { staticClass: "material-icons" },
                                              [_vm._v("keyboard_arrow_left")]
                                            ),
                                            _vm._v(
                                              " Previous\n                      "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._l(_vm.totalPages, function (n, index) {
                                    return _vm.currentPage > 0
                                      ? _c(
                                          "li",
                                          {
                                            key: index,
                                            staticClass: "mr-1",
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.showPage(index)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                class: {
                                                  "pagination-active":
                                                    index + 1 ==
                                                    _vm.currentPage,
                                                },
                                                attrs: { href: "" },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(index + 1) +
                                                    "\n                      "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e()
                                  }),
                                  _vm.currentPage < _vm.totalPages
                                    ? _c("li", [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "pagination-next",
                                            attrs: { href: "" },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.showPage(
                                                  _vm.currentPage
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                        Next "
                                            ),
                                            _c(
                                              "i",
                                              { staticClass: "material-icons" },
                                              [_vm._v("keyboard_arrow_right")]
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "processing_popup full-spinner",
        staticStyle: { visibility: "visible" },
      },
      [
        _c("div", { staticClass: "spinner" }, [
          _c("div", { staticClass: "bounce1" }),
          _c("div", { staticClass: "bounce2" }),
          _c("div", { staticClass: "bounce3" }),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-upload-i" }, [
      _c("span", { staticClass: "d-block mb-2" }, [
        _vm._v("png, jpeg, pdf and "),
        _c("span", [_vm._v(" less than\n                    4 MB")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("S. No.")]),
        _c("th", [_vm._v("File Name")]),
        _c("th", [_vm._v("Action")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }